<template>
    <LayoutDefault>
        <div class="container-fluid banner-plb pb-5 camera-page"
            :style="{ backgroundImage: `url(${images_fpt(banner.path, banner.mob)})` }">
            <div class="backdrop-image"></div>
            <section-banner :module="module" :title="label.pageTitle" :description="label.pageDescription"></section-banner>
            <SectionTypeSekeleton v-if="isFirstLoaded">
                <template #body>
                    <div class="d-flex box flex-column flex-md-row">
                        <b-skeleton-img card-img="left" width="400px" height="300px"></b-skeleton-img>
                        <div class="flex-fill">
                            <b-skeleton-table :rows="7" :columns="2"></b-skeleton-table>
                        </div>
                    </div>
                </template>
            </SectionTypeSekeleton>
            <div v-else>
                <section-type idSection="smart-home" :title="label.pageTitle" :tabs="sectionTabsData" :loading="loading"
                    :optionQuantity="optionQuantity" :label="label" v-model="selectedTab" @input="tabBinding"
                    @onProgress="onProgress" module="smart-home" @computed-commingSoon="handleCommingSoon" v-if="sectionTabsData.length > 0">
                    <div :slot="tab.CmsContent.service_code" v-for="(tab, tabIndex) in sectionTabsData"
                        class="d-flex box flex-column flex-md-row"
                        :key="`section-choose-package-camera-${tabIndex}-${tab.CmsContent.service_code}`">
                        <section-images v-if="imageList && imageList.length > 0" :images="imageList"></section-images>
                        <div class="flex-fill">
                            <div class="row" v-if="tab.CmsContent.content.smarthome_content_promotion">
                                <div class="col-12">
                                    <div class="sticky-note d-flex align-items-center mb-3">
                                        <p class="text-bold text-16 clo-green m-0"
                                            v-html="tab.CmsContent.content.smarthome_content_promotion"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-for="(feature, index) in tab.CmsContent.content.features"
                                :key="`tab-${tabIndex}-detail-${index}`">
                                <div class="col-4">
                                    <p class="text-bold clo-black" v-text="feature.smarthome_feature_name"></p>
                                </div>
                                <div class="col-8">
                                    <p class="text-med clo-black76" v-text="feature.smarthome_feature_description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section-type>
            </div>
            <section-function :functions="functionList"></section-function>
            <News :sectionSliderData="sectionSliderData" :destroyMobile="false" ref="sectionNews"
                v-if="sectionSliderData.length > 0"></News>
            <section-function customItemPerRowClass="col-4" class="section-terms"
                :functions="sectionTermData"></section-function>
            <div class="container p-0 smart-home--link">
                <p>Miễn phí hoàn trả khi có lỗi từ nhà sản xuất. Chi tiết vui lòng truy cập <a rel="noopener noreferrer" target="_blank" href="https://fptsmarthome.vn/chinh-sach-bao-hanh#doi-tra">chính sách đổi trả hàng</a></p>
            </div>
            <section-question></section-question>
            <div class="d-flex justify-content-center">
                <a class="btn btn-custom orange mt-3 mx-auto" style="min-width: 300px; margin-bottom: 55px"
                    href="javascript:;" @click="onProgress"><span>{{ commingSoon ? 'Chưa mở bán' : 'Mua ngay'
                    }}</span></a>
            </div>
        </div>
        <b-modal id="note-modal" hide-footer centered>
            <template #modal-title>
                <div class="d-flex align-items-center">
                    <div class="d-flex mr-3">
                        <icon iconName="icon-info-orange" class="ico-orange"></icon>
                    </div>
                    <span class="modal-title">{{ label.note }}</span>
                </div>
            </template>
            <p v-html="label.noteDescription"></p>
        </b-modal>
        <!-- <section-footer></section-footer> -->
    </LayoutDefault>
</template>

<script>
import {
    MAX_QUANTITY,
    MIN_QUANTITY,
    SERVICE_CODE,
    BASE_URL
} from '../../../configs/constants';
import * as api from '../module/api';
import * as cms from '../module/cms';
import * as api_ultra from '../../ultraFast/module/api';
import isMobile from '@/mycore/utils/mobile-detect';
import { mixins } from '../../mixin';
import News from '../components/sectionNews.vue';
import { getNewsList } from '@/mycore/module/cms';
import SectionTypeSekeleton from '@/mycore/components/SectionTypeSekeleton.vue';
const PAGE_SERVICE_CODE = SERVICE_CODE.SMARTHOME;
export default {
    mixins: [mixins],
    components: { News, SectionTypeSekeleton, SectionTypeSekeleton },
    data() {
        return {
            banner: {
                path: 'https://hi-static.fpt.vn/sys/shop/prod/2022-06-01/6296defa5a811_424f1c09-cc93-4162-a982-5f16dd16accb.jpg',
                mob: 'https://hi-static.fpt.vn/sys/shop/prod/2022-06-01/6296defa5a811_424f1c09-cc93-4162-a982-5f16dd16accb.jpg',
                alt: '',
            },
            loading: true,
            image: null,
            module: 'smart-home',
            label: {
                pageTitle: 'FPT Smart Home',
                pageDescription: '',
                note: 'Chú thích',
                noteDescription:
                    'Miễn phí lắp đặt lần đầu cho khách hàng đang sử dụng Internet FPT.<br />Quý khách vui lòng điền số CMND dùng cho hợp đồng internet hiện tại và chọn đúng vị trí muốn lắp đặt Camera để nhận ưu đãi',
                buyNow: 'Mua ngay',
                comingSoon: 'Chưa mở bán',
                NonPackagesMessage: 'Hiện tại, sản phẩm/ dịch vụ mà quý khách đã chọn chưa hỗ trợ chính sách mở bán tại khu vực của quý khách. Mời quý khách kiểm tra lại khu vực đã chọn hoặc chọn đăng ký sản phẩm/dịch vụ khác. Liên hệ 1900 6600 để được tư vấn giải đáp. Xin cảm ơn.',
            },
            commingSoon: true,
            selectedTab: {},
            imageList: [],
            listMeta: {},
            optionQuantity: {
                maxValue: MAX_QUANTITY,
                minValue: MIN_QUANTITY,
            },
            isFirstLoaded: true,
            sectionTabsData: [],
            sectionFunctionsData: {
                'o-cam-wifi': [
                    {
                        backgroundClass: 'func-setting',
                        icon: '/assets/images/camera4.png',
                        label: 'Điều khiển thiết bị điện từ xa qua App'
                    },
                    {
                        backgroundClass: 'func-support',
                        icon: '/assets/images/timer.png',
                        label: 'Hẹn giờ tự động cho mọi thiết bị',
                    },
                    {
                        backgroundClass: 'func-call-center',
                        icon: '/assets/images/camera-signal.png',
                        label: 'Tương thích đa dạng loại phích cắm',
                    },
                    {
                        backgroundClass: 'func-remote-management',
                        icon: '/assets/images/code-download.png',
                        label: 'Tạo kịch bản thông minh theo thói quen hằng ngày',
                    }
                ],
                'bo-dieu-khien-hong-ngoai-thong-minh': [
                    {
                        backgroundClass: 'func-setting',
                        icon: '/assets/images/thermometer-plus.png',
                        label: 'Điều khiển máy lạnh dễ dàng từ xa qua App'
                    },
                    {
                        backgroundClass: 'func-support',
                        icon: '/assets/images/timer.png',
                        label: 'Hẹn giờ hoạt động theo nhu cầu',
                    },
                    {
                        backgroundClass: 'func-call-center',
                        icon: '/assets/images/star.png',
                        label: 'Tạo ngữ cảnh thông minh giúp tiết kiệm điện năng',
                    },
                    {
                        backgroundClass: 'func-remote-management',
                        icon: '/assets/images/loader.png',
                        label: 'Tín hiệu hồng ngoại đa hướng, cho phép điều khiển từ mọi vị trí',
                    }
                ]
            },
            sectionTermData: [
                {
                    icon: '/assets/images/support1.png',
                    label: 'Bảo hành 24 tháng',
                },
                {
                    icon: '/assets/images/support2.png',
                    label: 'Hướng dẫn cài đặt & sử dụng',
                },
                {
                    icon: '/assets/images/support3.png',
                    label: 'Hỗ trợ khách hàng 24/7',
                },
            ],
            sectionSliderData: [],
            dataQuery: null
        };
    },
    created() {
        this.dataQuery = this.$route.query
        if(Object.keys(this.dataQuery).length !== 0){
            sessionStorage.info_tracking_url = JSON.stringify(this.dataQuery)
        }
        // xu ly khi du lieu parse khong dung
        try {
            this.listMeta = JSON.parse(localStorage.getItem('meta_seo'));
        } catch (e) {};
        this.loadCachedData();
        localStorage.removeItem("clearedSession"); // Xoá cờ để tránh lặp
    },
    mounted() {
        this.load();
        this.getUTM();
        this.getTracking()
    },
    computed: {
        functionList() {
            return this.sectionFunctionsData[this.selectedTab?.CmsContent?.service_code] || [];
        },
    },
    watch: {
        selectedTab(value) {
            if (value) {
                this.imageList = value?.CmsContent?.content?.images?.map((image) => {
                    return {
                        src: isMobile() && image.smarthome_image_mobile_path ? image.smarthome_image_mobile_path : image.smarthome_image_path,
                        alt: image.smarthome_image_alt,
                        position: image.position,
                    };
                }) || [] ;
                this.getMetaSeo();
                this.getNewsListByTab()
            }
        },
    },

    methods: {
        clearSession() {
            this.$store.dispatch('ultraFast/clearSession');
            this.$store.dispatch('fptplay/clearSession');
            this.$store.dispatch('fptplaybox/clearSession');
            this.$store.dispatch('camera/clearSession');
            this.$store.dispatch('cloud/clearSession');
            this.$store.dispatch('fsafe_go_extend/clearSession');
            this.$store.dispatch('internet/clearSession');
            this.$store.dispatch('smart-home/clearSession');
        },
        handleCommingSoon(e) {
            this.commingSoon = e;
        },

        loadCachedData() {
            const smarthomeLocalData = this.$store.getters['smart-home/smarthomeLocalData'];
            if (smarthomeLocalData) {
                const { Tabs, Label, Banner } = smarthomeLocalData;
                this.sectionTabsData = Tabs || [];
                if (Label) {
                    this.label = {
                        ...this.label,
                        ...Label,
                    };
                }
                this.banner = Banner ?? this.banner;
                if (this.sectionTabsData.length > 0) {
                    this.getCurrentTab();
                }
                this.isFirstLoaded = false;
            }
        },
        getUTM() {
            if (this.$route.query.utm_source) {
                sessionStorage.utm_source = this.$route.query.utm_source || '';
                sessionStorage.utm_medium = this.$route.query.utm_medium || '';
                sessionStorage.utm_campaign = this.$route.query.utm_campaign || '';
                sessionStorage.utm_term = this.$route.query.utm_term || '';
                sessionStorage.utm_content = this.$route.query.utm_content || '';
            }
            if (this.$route.query.aff_sid) {
                sessionStorage._aff_sid = this.$route.query.aff_sid || '';

                const d = new Date();
                d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
                let expires = 'expires=' + d.toUTCString();
            }
        },
        getCurrentTab() {
            const routeName = this.$route.params['servicecode'];
            this.selectedTab = this.sectionTabsData.find((tab) => tab.CmsContent.route_name == routeName) || this.sectionTabsData[0];
            if(sessionStorage.info_tracking_url){
                let data = JSON.parse(sessionStorage.info_tracking_url)
                if(data?.guestid || Object.values(data).length !== 0){
                    this.$router.push({
                        path: `/${PAGE_SERVICE_CODE}/${this.selectedTab.CmsContent.route_name}`,
                        query:  {
                                    fullname: data?.fullname || '',
                                    phonenumber: data?.phonenumber || '',
                                    locationid: data?.locationid || '',
                                    districtid: data?.districtid || '',
                                    wardid: data?.wardid || '',
                                    utm_source: data?.utm_source || '',
                                    utm_medium: data?.utm_medium || '',
                                    utm_campaign: data?.utm_campaign || '',
                                    guestid: data?.guestid || '',
                                }
                    }).catch(() => {});
                }else{
                    this.$router.push({
                        path: `/${PAGE_SERVICE_CODE}/${this.selectedTab.CmsContent.route_name}`
                    }).catch(() => { });
                }
            }else{
                this.$router.push({
                    path: `/${PAGE_SERVICE_CODE}/${this.selectedTab.CmsContent.route_name}`
                }).catch(() => { });
            }
            this.imageList = this.selectedTab?.CmsContent?.content?.images?.map((image) => ({
                src: isMobile() && image.smarthome_image_mobile_path ? image.smarthome_image_mobile_path : image.smarthome_image_path,
                alt: image.smarthome_image_alt,
                position: image.position,
            })) || [];
            this.getMetaSeo();
        },
        load() {
            sessionStorage.isPage = 'SmartHome';
            this.clearSession();
            cms.getLandingBanner(this.mappingBanner, PAGE_SERVICE_CODE);
            api.getCategories(this.getCategoriesCallback);
        },
        getCategoriesCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    const response = data.data;
                    const cachedTabsData = this.$store.getters['smart-home/Tabs'];

                    this.sectionTabsData = response.map(item => {
                        const temp = cachedTabsData.find(tab => tab.CmsContent.service_code === item.service_code);
                        return {
                            ...item,
                            Qty: temp ? temp?.Qty : 1,
                        }
                    });
                    this.$store.dispatch('smart-home/updateTabs', this.sectionTabsData);
                    if(this.sectionTabsData.length > 0) {
                        this.getCurrentTab();
                    }
                    this.loading = false;
                }
                else {
                    if (this.sectionTabsData.length > 0) {
                        this.sectionTabsData.forEach(item => {
                            item.RealPromotionMonth = 0
                            item.RealMonth = 0
                        })
                        this.getCurrentTab();
                    } else {
                        this.$store.dispatch('system/showDialog', {
                            title: 'Thông báo',
                            description: this.label.NonPackagesMessage,
                        });
                        this.$router.push({ name: 'homepage' }).catch(() => { });
                    }
                }
            } else {
                if (this.sectionTabsData.length > 0) {
                    this.sectionTabsData.forEach(item => {
                        item.RealPromotionMonth = 0
                        item.RealMonth = 0
                    })
                } else {
                    this.$store.dispatch('system/showDialog', {
                        title: 'Thông báo',
                        description: this.label.NonPackagesMessage,
                    });
                    this.$router.push({ name: 'homepage' }).catch(() => { });
                }
            }
            this.loading = false;
        },
        getMetaSeo() {
            if (Object.keys(this.listMeta).length > 0) {
                document.title = this.listMeta[this.selectedTab.CmsContent.service_code].title;
                document.getElementsByTagName('meta')['keywords'].content =
                    this.listMeta[this.selectedTab.CmsContent.service_code].keywords;
                document.getElementsByTagName('meta')['description'].content =
                    this.listMeta[this.selectedTab.CmsContent.service_code].description;
                document
                    .querySelector('meta[property="og:url"]')
                    .setAttribute(
                        'content',
                        window.location.origin +
                        `/${PAGE_SERVICE_CODE}/${this.selectedTab.CmsContent.service_code}`
                    );
                document.querySelector('meta[property="og:type"]').setAttribute('content', 'article');
                document
                    .querySelector('meta[property="og:title"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].title);
                document
                    .querySelector('meta[property="og:description"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].description);
                document
                    .querySelector('meta[property="og:image"]')
                    .setAttribute('content', this.listMeta[this.selectedTab.CmsContent.service_code].thumbnail);
            }

        },
        getNewsListByTab() {
            const slider = this.$store.getters['smart-home/News'];
            if (slider) {
                if (slider[this.selectedTab.CmsContent.service_code]) {
                    this.sectionSliderData = slider[this.selectedTab.CmsContent.service_code];
                }
                else {
                    getNewsList(this.mapingNewSlider, this.selectedTab.CmsContent.service_code);
                }
            }
            else {
                getNewsList(this.mapingNewSlider, this.selectedTab.CmsContent.service_code);
            }
        },
        tabBinding($e) {
            this.selectedTab = $e;
        },
        mapingNewSlider: function (isSuccess, data, error) {
            if (isSuccess && data.error === 0) {
                this.sectionSliderData = data.data;
                const service_code = this.selectedTab.CmsContent.service_code
                const newsList = {
                    ...this.$store.getters['smart-home/News'],
                    [service_code]: data.data,
                };
                this.$store.dispatch('smart-home/updateNews', newsList);
            }
        },
        mappingBanner: function (isSuccess, data, error) {
            if (isSuccess && data.error === 0) {
                const content = data.data;
                this.label = {
                    ...this.label,
                    pageTitle: content.landing_page_title,
                    pageDescription: content.landing_page_subtitle,
                };
                this.banner = {
                    ...this.banner,
                    path: content.landing_page_banner_path,
                    alt: content.landing_page_banner_alt,
                    mob: content.landing_page_banner_mobile_path,
                };
                this.$store.dispatch('smart-home/updateBanner', this.banner);
                this.$store.dispatch('smart-home/updateLabel', this.label);
            }
        },
        onProgress() {
            if (this.loading || this.commingSoon) return;
            this.$store.dispatch('smart-home/updateSelectedPackage', this.selectedTab);
            if(this.selectedTab?.CategoryService[0]){
                sessionStorage.service_tracking = JSON.stringify(this.selectedTab.CategoryService[0])
            }
            window.scrollTo(0, 0);
            if(sessionStorage.info_tracking_url){
                let data = JSON.parse(sessionStorage.info_tracking_url)
                if(data?.guestid || Object.values(data).length !== 0){
                    this.$router.push({
                        name: 'smart-home.registerWithSCode',
                        params: { servicecode: this.selectedTab.CmsContent.route_name },
                        query:  {
                                    fullname: data?.fullname || '',
                                    phonenumber: data?.phonenumber || '',
                                    locationid: data?.locationid || '',
                                    districtid: data?.districtid || '',
                                    wardid: data?.wardid || '',
                                    utm_source: data?.utm_source || '',
                                    utm_medium: data?.utm_medium || '',
                                    utm_campaign: data?.utm_campaign || '',
                                    guestid: data?.guestid || '',
                                }
                    }).catch(() => {});
                }else{
                    this.$router.push({ name: 'smart-home.registerWithSCode', params: { servicecode: this.selectedTab.CmsContent.route_name } }).catch(() => { });
                }
            }else{
                this.$router.push({ name: 'smart-home.registerWithSCode', params: { servicecode: this.selectedTab.CmsContent.route_name } }).catch(() => { });
            }
        },
        getTracking(){
            if(this.dataQuery){
                if(this.dataQuery.guestid){
                    let payload = {
                        GuestId: this.dataQuery.guestid || '',
                        LocationInfo: {
                            LocationId: parseInt(this.dataQuery?.locationid),
                            DistrictId: parseInt(this.dataQuery?.districtid),
                            WardId: parseInt(this.dataQuery?.wardid),
                            StreetId: parseInt(this.dataQuery?.streetid) || 0
                        },
                         CustomerInfo: {
                            FullName: this.dataQuery?.fullname || '',
                            PhoneNumber: this.dataQuery?.phonenumber || '',
                        },
                        ServiceInfo: null,
                        CampInfo: {
                            CampSource: this.dataQuery.utm_source || "",
                            CampMedium: this.dataQuery.utm_medium || "",
                            CampName: this.dataQuery.utm_campaign || ""
                        },
                        Actions: [
                            {
                                PageType: "LandingPage", /* LandingPage,HomePage,RegisterPage,ServicePage,PaymentPage,FinishPage */
                                Description: 'LandingPage SmartHome',
                                SessionId: "",
                                Url: BASE_URL + this.$route.path || "",
                                SpendTime: 0,
                                ActionTime: Date.now(),
                                ActionType: 'View'
                            }
                        ]
                    }
                    api_ultra.createTracking(this.callbackCreateTracking, payload);
                }
            }
        },
        callbackCreateTracking(){}
    },
};
</script>
<style scoped>
.list-btn {
    margin: 9px 9px 0 !important;
    border-bottom: 1px solid #e8e8e8;
}
.camera__box--padding-block-end {
    padding-block-end: 20px;
}
.smart-home--link{
    display: flex;
    align-items: center;
    justify-content: center;
}
.smart-home--link p{
    margin-bottom: 0;
    font-style: italic;
    font-size: 14px;
    line-height: 22px;
}
.smart-home--link a{
    margin-bottom: 0;
    font-style: italic;
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    color: #3F3F3F;
    text-decoration: underline;
}
</style>
